/** @format */

import { Container } from "../../components/layouts/Container";
import EmochiEconomicEstimateCheckElement from "../../components/ui_elements/emochi/Economic/EconomicEstimateCheckElement";

const EmochiEconomicEstimateCheck = ({ redirect }: { redirect?: boolean }) => {
  return (
    <Container isLogin={true} background={"default"} align={"top"} redirect={redirect}>
      <EmochiEconomicEstimateCheckElement redirect={redirect} />
    </Container>
  );
};

export default EmochiEconomicEstimateCheck;
